//footer options
export const footerOptions:any[] = [
    {
        header:"Shopping with us",
        options:["Making payments", "Delivery options", "Buyer Protection"]
    },
    {
        header:"Useful links",
        options:["Pricing", "Settings", "Orders","Help"]
    }
];